import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import ReactEditorViewContext from './ReactEditorViewContext';

class WithOutsideClick extends PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleClick", evt => {
      if (!this.props.isActiveComponent) {
        return;
      }

      const domNode = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

      if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
        if (this.props.handleClickOutside) {
          this.props.handleClickOutside(evt);
        }
      }
    });

    _defineProperty(this, "handleKeydown", evt => {
      if (!this.props.isActiveComponent) {
        return;
      }

      if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
        var _this$props$editorVie;

        evt.preventDefault();
        evt.stopPropagation();
        this.props.handleEscapeKeydown(evt);

        if (!((_this$props$editorVie = this.props.editorView) !== null && _this$props$editorVie !== void 0 && _this$props$editorVie.hasFocus())) {
          var _this$props$editorVie2;

          (_this$props$editorVie2 = this.props.editorView) === null || _this$props$editorVie2 === void 0 ? void 0 : _this$props$editorVie2.focus();
        }

        return false;
      } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) {
        this.props.handleEnterKeydown(evt);
      }
    });
  }

  componentDidMount() {
    if (this.props.handleClickOutside) {
      document.addEventListener('click', this.handleClick, false);
    }

    if (this.props.handleEscapeKeydown) {
      var _this$props$editorRef;

      (((_this$props$editorRef = this.props.editorRef) === null || _this$props$editorRef === void 0 ? void 0 : _this$props$editorRef.current) || document).addEventListener('keydown', this.handleKeydown, false);
    }
  }

  componentWillUnmount() {
    if (this.props.handleClickOutside) {
      document.removeEventListener('click', this.handleClick, false);
    }

    if (this.props.handleEscapeKeydown) {
      var _this$props$editorRef2;

      (((_this$props$editorRef2 = this.props.editorRef) === null || _this$props$editorRef2 === void 0 ? void 0 : _this$props$editorRef2.current) || document).removeEventListener('keydown', this.handleKeydown, false);
    }
  }

  render() {
    return this.props.children;
  }

}

function hasIsOpen(props) {
  return 'isOpen' in props;
}

export default function withReactEditorViewOuterListeners(Component) {
  return ({
    handleClickOutside,
    handleEnterKeydown,
    handleEscapeKeydown,
    ...props
  }) => {
    const isActiveComponent = hasIsOpen(props) ? props.isOpen : true;
    return /*#__PURE__*/React.createElement(ReactEditorViewContext.Consumer, null, ({
      editorView,
      editorRef
    }) => /*#__PURE__*/React.createElement(WithOutsideClick, {
      editorView: editorView,
      editorRef: editorRef,
      isActiveComponent: isActiveComponent,
      handleClickOutside: handleClickOutside,
      handleEnterKeydown: handleEnterKeydown,
      handleEscapeKeydown: handleEscapeKeydown
    }, /*#__PURE__*/React.createElement(Component, props)));
  };
}